module.exports = __webpack_public_path__ + "static/img/balloon@3x.d497328.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/balloon@3x.png
// module id = 907m
// module chunks = 1